import { useMutation } from "@tanstack/react-query";
import FetchClients, { ClientPaths } from "../client";

const validateAddress = {
  useManualQuery,
};

export default validateAddress;

function useManualQuery({ onError }: { onError?: (e: any) => void } = {}) {
  return useMutation({
    mutationFn: async (
      query: ClientPaths["site"]["/validate-address"]["get"]["parameters"]["query"]
    ) => {
      const { response, error } = await FetchClients.site.GET(
        "/validate-address",
        {
          params: { query },
        }
      );
      if (response.ok) return;
      if (onError) {
        onError(error);
      } else {
        throw new Error(
          `Error: ${
            response.status === 422 // Service returns 422 Unprocessable Entity if geocode fails
              ? "Failed to validate address"
              : error ?? "Unknown error"
          }`
        );
      }
    },
  });
}
